export default __webpack_public_path__ + "66bf7aeb1541d4d245f8e2f9c8ef4b07.png";